import Tab from "components/common/Tab/tab";
import Tabs from "components/common/Tab/tabs";
import { useTabTracking } from "lib/analytics/react/hooks";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { useState, useEffect } from "react";
import { TYPO } from "styles/Typo";

function MainNavgation({ isMobile }: { isMobile: boolean }) {
  const router = useRouter();
  const { t } = useTranslation("main");
  const { type } = router.query;
  const [isNewFeed, setIsNewFeed] = useState(false);
  const { trackClick } = useTabTracking("main_tab_click", [
    "explore",
    "my",
    "portfolio",
    "feed",
    "kb",
  ]);

  useEffect(() => {
    const fetchNewFeed = async () => {
      const lastDate = localStorage.getItem("feed-click");

      const response = await fetch(
        "/api/feednew" + (lastDate ? "?lastDate=" + lastDate : "")
      );
      const data = await response.json();
      setIsNewFeed(data);
    };
    fetchNewFeed();
  }, []);

  return (
    <div
      className="w-full"
      style={{
        position: isMobile ? "sticky" : "sticky",
        top: isMobile ? "0px" : "64px",
        zIndex: 31,
      }}
    >
      <Tabs type="line">
        <Tab
          title={t("navExplore")}
          onClick={() => {
            window.dataLayer.push({
              event: "cMainTabExplore",
            });
            trackClick("explore");
            router.push("?type=explore", undefined, { shallow: true });
          }}
          isActive={!type || type === "" || type === "explore"}
          type={"line"}
          tabClassNameAdd={`!py-[14px] ${TYPO.TYPO5_SB} !leading-[28px] 
          ${
            "!border-0"
          }`}
        />

        <Tab
          title={t("navWatchlist")}
          onClick={() => {
            window.dataLayer.push({
              event: "cMainTabMy",
            });
            trackClick("my");
            router.push("?type=my", undefined, { shallow: true });
          }}
          isActive={type === "my"}
          type={"line"}
          tabClassNameAdd={`!py-[14px] ${TYPO.TYPO5_SB} !leading-[28px] ${
            "!border-0"
          }`}
        />
        <Tab
          title={t("navDiagnosis")}
          onClick={() => {
            window.dataLayer.push({
              event: "cMainTabPortfolio",
            });
            trackClick("portfolio");
            router.push("?type=portfolio", undefined, { shallow: false });
          }}
          isActive={type === "portfolio"}
          type={"line"}
          tabClassNameAdd={`!py-[14px] ${
            TYPO.TYPO5_SB
          } !leading-[28px] ${"!border-0"}`}
        />

        <div
          data-gtm-id={"cMainTabFeed"}
          className={`${TYPO.TYPO5_SB} ${
            type === "feed"
              ? "text-black  border-black relative common-active-tab"
              : `text-gray40 `
          } px-2 py-[14px] ${TYPO.TYPO5_SB} !leading-[28px] ${
            type === "feed" ? "" : ""
          } text-center cursor-pointer flex gap-[2px] shrink-0 justify-center  `}
          onClick={() => {
            window.dataLayer.push({
              event: "cMainTabFeed",
            });
            trackClick("feed");
            router.push("?type=feed", undefined, { shallow: true });
            localStorage.setItem("feed-click", new Date().getTime().toString());
            setIsNewFeed(false);
          }}
        >
          <span>{t("navFeed")}</span>
          {isNewFeed && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="6"
              height="6"
              viewBox="0 0 6 6"
              fill="none"
            >
              <circle cx="3" cy="3" r="3" fill="var(--red40)" />
            </svg>
          )}
        </div>
        {isMobile && router.locale === "ko" && (
          // <Tab
          //   title={"KB 증권"}
          //   onClick={() => {
          //     window.dataLayer.push({
          //       event: "cMainTabKBStock",
          //     });
          //     router.push("?type=stock", undefined, { shallow: true });
          //   }}
          //   isActive={type === "stock"}
          //   type={"line"}
          //   tabClassNameAdd={`!py-[14px] ${TYPO.TYPO5_SB} !leading-[28px] ${
          //     // type === "stock" ? "!border-b-[2.5px]" : ""
          //     "!border-0"
          //   }`}
          // />
          <div
            data-gtm-id={"cMainTabStock"}
            className={`${TYPO.TYPO5_SB} ${
              type === "stock"
                ? "text-black  border-black relative common-active-tab"
                : `text-gray40 `
            } px-2 py-[14px] ${TYPO.TYPO5_SB} !leading-[28px] ${
              type === "stock" ? "" : ""
            } text-center cursor-pointer flex gap-[2px] shrink-0 justify-center items-center  `}
            onClick={() => {
              window.dataLayer.push({
                event: "cMainTabStock",
              });
              trackClick("kb");
              router.push("?type=stock", undefined, { shallow: true });
            }}
          >
            <span>KB증권</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <mask
                id="mask0_22720_25823"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="16"
              >
                <rect width="16" height="16" fill={"#D9D9D9"} />
              </mask>
              <g mask="url(#mask0_22720_25823)">
                <path
                  d="M10.6662 5.59992L4.73288 11.5333C4.61066 11.6555 4.4551 11.7166 4.26621 11.7166C4.07732 11.7166 3.92177 11.6555 3.79954 11.5333C3.67732 11.411 3.61621 11.2555 3.61621 11.0666C3.61621 10.8777 3.67732 10.7221 3.79954 10.5999L9.73288 4.66659H4.66621C4.47732 4.66659 4.31899 4.6027 4.19121 4.47492C4.06343 4.34714 3.99954 4.18881 3.99954 3.99992C3.99954 3.81103 4.06343 3.6527 4.19121 3.52492C4.31899 3.39714 4.47732 3.33325 4.66621 3.33325H11.3329C11.5218 3.33325 11.6801 3.39714 11.8079 3.52492C11.9357 3.6527 11.9995 3.81103 11.9995 3.99992V10.6666C11.9995 10.8555 11.9357 11.0138 11.8079 11.1416C11.6801 11.2694 11.5218 11.3333 11.3329 11.3333C11.144 11.3333 10.9857 11.2694 10.8579 11.1416C10.7301 11.0138 10.6662 10.8555 10.6662 10.6666V5.59992Z"
                  fill={type === "stock" ? "#000000" : "#B0B8C1"}
                />
              </g>
            </svg>
          </div>
        )}
      </Tabs>
    </div>
  );
}

export default MainNavgation;
